// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GGcL","col":"styles_col__KIaMD"};